/**
 * 特性展示区滚动交互效果
 */
document.addEventListener('DOMContentLoaded', function() {
  // 检查GSAP和ScrollTrigger是否可用
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    // 初始化滚动动画
    initFeatureShowcaseAnimations();
  } else {
    // GSAP未加载，加载GSAP库
    loadGSAP();
  }

  // 图片加载错误处理
  handleImageErrors();

  /**
   * 加载GSAP库和ScrollTrigger插件
   */
  function loadGSAP() {
    console.log('正在加载GSAP...');
    // 创建GSAP核心库脚本
    const gsapScript = document.createElement('script');
    gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js';
    gsapScript.onload = function() {
      // GSAP加载完成后加载ScrollTrigger
      const scrollTriggerScript = document.createElement('script');
      scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js';
      scrollTriggerScript.onload = function() {
        // 两个库都加载完成，初始化动画
        initFeatureShowcaseAnimations();
      };
      document.body.appendChild(scrollTriggerScript);
    };
    document.body.appendChild(gsapScript);
  }

  /**
   * 初始化特性展示区动画
   */
  function initFeatureShowcaseAnimations() {
    // 初始化ScrollTrigger（如果需要）
    if (typeof gsap.registerPlugin === 'function') {
      gsap.registerPlugin(ScrollTrigger);
    }

    console.log('初始化特性展示区动画...');
    
    // 特性展示 - 逐个显示元素动画
    gsap.to(".feature-showcase-animate1", {
        scrollTrigger: {
            trigger: ".feature-showcase-section .feature-showcase-container",
            scrub: true,
            start: "center 85%",
            end: "center 80%"
        },
        opacity: 1,
        ease: "none"
    });
    
    gsap.to(".feature-showcase-animate2", {
        scrollTrigger: {
            trigger: ".feature-showcase-section .feature-showcase-container",
            scrub: true,
            start: "center 80%",
            end: "center 75%"
        },
        opacity: 1,
        ease: "none"
    });
    
    gsap.to(".feature-showcase-animate3", {
        scrollTrigger: {
            trigger: ".feature-showcase-section .feature-showcase-container",
            scrub: true,
            start: "center 75%",
            end: "center 70%"
        },
        opacity: 1,
        ease: "none"
    });
    
    gsap.to(".feature-showcase-animate4", {
        scrollTrigger: {
            trigger: ".feature-showcase-section .feature-showcase-container",
            scrub: true,
            start: "center 70%",
            end: "center 65%"
        },
        opacity: 1,
        ease: "none"
    });
    
    gsap.to(".feature-showcase-animate5", {
        scrollTrigger: {
            trigger: ".feature-showcase-section .feature-showcase-container",
            scrub: true,
            start: "center 65%",
            end: "center 60%"
        },
        opacity: 1,
        ease: "none"
    });
    
    gsap.to(".feature-showcase-animate6", {
        scrollTrigger: {
            trigger: ".feature-showcase-section .feature-showcase-container",
            scrub: true,
            start: "center 60%",
            end: "center 55%"
        },
        opacity: 1,
        ease: "none"
    });
    
    gsap.to(".feature-showcase-animate7", {
        scrollTrigger: {
            trigger: ".feature-showcase-section .feature-showcase-container",
            scrub: true,
            start: "center 55%",
            end: "center 50%"
        },
        opacity: 1,
        ease: "none"
    });
  }

  /**
   * 处理图片加载错误
   */
  function handleImageErrors() {
    // 获取所有特性展示区的图片
    const featureImages = document.querySelectorAll('.feature-showcase-item img');
    
    // 为每个图片添加加载事件监听
    featureImages.forEach(function(img) {
      // 添加加载中状态
      img.parentElement.classList.add('loading');
      
      // 图片加载成功
      img.addEventListener('load', function() {
        img.parentElement.classList.remove('loading');
      });
      
      // 图片加载失败
      img.addEventListener('error', function() {
        console.warn('图片加载失败:', img.src);
        img.parentElement.classList.remove('loading');
        img.parentElement.classList.add('fallback');
        
        // 尝试使用默认占位符图片或灰色背景
        if (!img.src.includes('placeholder')) {
          // 设置一个灰色背景作为占位符
          img.style.display = 'none';
          img.parentElement.style.backgroundColor = '#e0e0e0';
        }
      });
    });
  }
}); 